$(document).foundation();

jQuery(document).ready(function($) {

  // show body - fix for font blinking
  $('body').addClass('is--showing')

  // mobile menu toggle
  $('.mobile-toggle').on('click', function() {
    $('.mobile-menu').toggleClass('mobile-menu--is-showing')
    $('html, body').toggleClass('overflow-hidden')
  })

  // book goode co  open contact modal
  $('a[href="#contact"], a[href="#book"]').on('click', function(e) {
    $('#reveal-contact').foundation('open'); // Open the modal directly
    e.preventDefault();
  })

  // hide mobile menu on open
  $(document).on('open.zf.reveal', '[data-reveal]', function () {
    $('.mobile-menu').removeClass('mobile-menu--is-showing')
    $('html, body').removeClass('overflow-hidden')
  })

  $('.main-menu .has-submenu').hover(
    function () {
      $(this).addClass('has-submenu--is-hovered')
    },
    function () {
      $(this).removeClass('has-submenu--is-hovered')
    }
  )

  $('.main-menu a.trigger').on('click', function(e) {
    e.preventDefault()
  })

  // bottom links open top link payloads
  $('footer a[href="#private-dining"], footer a[href="#menus"]').on('click', function(e) {
    var href = $(this).attr('href')
    var $a = $('.main-menu a[href="' + href + '"]')
    var $hasSubmenu = $a.parent()
    if ($hasSubmenu.hasClass('has-submenu--is-hovered')) {
      $hasSubmenu.removeClass('has-submenu--is-hovered')
    } else {
      $('.main-menu .has-submenu').removeClass('has-submenu--is-hovered')
      $a.trigger('mouseover')
    }
    e.preventDefault()
  })

  // newsletter subscribe
  var $formSubscribe = $('form.newsletter-form')
  $formSubscribe.on('submit', function(e) {
    var email = $formSubscribe.find('input[name="email"]').val()
    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'goodecatering_do_subscribe',
        email: email
      },
      cache: false,
      dataType: 'json',
      success: function(data) {
        if (data['success']) {
          $formSubscribe.addClass('state-success')
        }
        else {
          $formSubscribe.addClass('state-error').delay(4000).queue('fx', function() {
            $formSubscribe.removeClass('state-error')
          })
        }
      }
    })
    e.preventDefault()
    return false
  })

  $('.hero a').on('click', function(e) {
    var $a = $(this)
    var hash = $a.attr('href')
    if (hash === '#menus') {
      var $container = $('.page-template-page-menus .menu-container')
      var scrollTop = $container.offset().top
      scrollTop -= $(window).width() < 970 ? 60 : 0
      $('html, body').animate({ scrollTop: scrollTop  }, 500)
      e.preventDefault()
    }
    else if (hash === '#venues') {
      var $container = $('.page-template-page-menus .venues')
      var scrollTop = $container.offset().top
      $('html, body').animate({ scrollTop: scrollTop  }, 500)
      e.preventDefault()
    }
  })

  var hash = window.location.hash
  if (hash === '#privacy-policy') {
    $('html, body').animate({ scrollTop: $(hash).offset().top - 30}, 0)
  }

  $('.catering-toggle').on('click', function(e) {
    $(this).parent().find('.payload').toggleClass('payload--is-open')
    $(this).toggleClass('catering-toggle--is-open')
    e.preventDefault()
  })

  // faq toggle
  $('.qa .trigger').on('click', function(e) {
    $(this).parent().toggleClass('item--open')
    e.preventDefault()
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
